
import Vue from 'vue';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default Vue.extend({
	name: 'TokenRevealDialog',
	components: {
		DialogOrBottomSheet,
		ClipboardCopy,
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		token: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: 'Copy your token',
		},
		description: {
			type: String,
			default: 'Copy this token now. You will not be able to see it again.',
		},
	},
});
